module.exports = __webpack_public_path__ + "28ac5ad41796711bfe061af787b1bc7e.svg";